import React from 'react';
import Banner from "./Banner"
import About from './AboutSection';
import SlidingTextOne from '../../components/Common/SlidingTextOne ';
import CounterOne from './CounterOne';
import CTAOne from './CTAOne';
import ContactOne from './ContactOne';
import Team from './Team';
import WeServe from './WeServe';
import FaqOne from './FaqOne';
import ProjectOne from './ProjectOne';
import Blog from './Blog';
import BrandOne from './BrandOne';
import TestimonialOne from './TestimonialOne';
import ServicesOne from './ServicesOne';


const HomeMain = () => {
	return (
		<React.Fragment>
			<Banner />
			<About />
			<SlidingTextOne />
			<ServicesOne />
			<CounterOne />
			<CTAOne />
			<Team />
			<ContactOne />
			<WeServe />
			<TestimonialOne />
			<ProjectOne />
			<BrandOne />
			<FaqOne />
			<Blog />
		</React.Fragment>
	);
}

export default HomeMain;